// 同意文言一覧
import React from 'react';
import { render } from 'react-dom';
import { Row, Col } from 'react-bootstrap';

const CustomerDocumentComplete = () => {
  // data属性からmodeを取得する
  const node = document.getElementById('customer-document-complete');
  const mode = node?.dataset.mode;

  // 完了メッセージの出力
  const jsxCompleteMessage = () => {
    if (mode === 'delete') {
      return (<>顧客宛文書の削除が完了しました。</>)
    } else if (mode === 'edit') {
      return (<>顧客宛文書の編集が完了しました。</>)
    }
    return (<></>);
  };

  // 顧客宛文書一覧へボタン押下時の処理
  const handleClickReturn = () => {
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/customer_document/list`);
  };

  return (
    <div className="maintenance">
      <div className="title">顧客宛文書</div>
      <div className="maintenance_container">
        <div className="contents">
          <div className="page-title">顧客宛文書編集(完了)</div>
          <br />
          <p className="text-center">
            {jsxCompleteMessage()}<br />
            {mode === 'edit' && '承認者に登録内容の確認を依頼して下さい(本画面では、承認者へのワークフロー通知は行われません)。'}
          </p>
        </div>
        <Row className="footer-button-block mt-3">
          <Col className="footer-btn">
            <a className={`btn btn-mini btn-success`} onClick={handleClickReturn}>顧客宛文書一覧へ</a>
          </Col>
        </Row>
      </div>
    </div>
  );
};

if (document.getElementById('customer-document-complete')) {
  render(<CustomerDocumentComplete />, document.getElementById('customer-document-complete'));
}
